import { render } from "./connection_order.vue?vue&type=template&id=35f5b854"
import script from "./connection_order.vue?vue&type=script&lang=js"
export * from "./connection_order.vue?vue&type=script&lang=js"

import "./connection_order.vue?vue&type=style&index=0&id=35f5b854&lang=scss"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__